module.exports = __webpack_public_path__ + "c66ab232c6b90c2bde3656d467a9980c.svg";